import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface CSImageProps {
  src: string;
  alt: string;
  className?: string;
  lazy?: boolean;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  horizontalAlign?: 'left' | 'center' | 'right';
}

const ConsistentSpaceImage: React.FC<CSImageProps> = ({
  src,
  alt,
  className = '',
  lazy = true,
  verticalAlign = 'middle',
  horizontalAlign = 'center',
}) => {
  const ImageComponent = lazy ? LazyLoadImage : 'img';
  const verticalClass = `align-${verticalAlign}`;
  const horizontalClass = `align-${horizontalAlign}`;

  return (
    <div className={`consistent-space-image-container ${verticalClass} ${horizontalClass} ${className}`}>
      <div className="consistent-space-inner-container">
        <ImageComponent src={src} alt={alt} className="foreground" />
        <ImageComponent src={src} alt="" className="background" aria-hidden={true} />
      </div>
    </div>
  );
};

export default ConsistentSpaceImage;
